 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about~home~products~projects~services":"about~home~products~projects~services","about":"about","home":"home","add-album~add-banner~add-company~add-member~add-news~add-product~add-testimonial~edit-album~edit-com~bfaa3580":"add-album~add-banner~add-company~add-member~add-news~add-product~add-testimonial~edit-album~edit-com~bfaa3580","add-album~edit-album":"add-album~edit-album","add-album":"add-album","edit-album":"edit-album","add-banner":"add-banner","add-company":"add-company","add-member":"add-member","add-news~add-product~add-testimonial~edit-editable-content~edit-news~edit-product~edit-testimonial~f~2d145b4d":"add-news~add-product~add-testimonial~edit-editable-content~edit-news~edit-product~edit-testimonial~f~2d145b4d","add-news":"add-news","add-product":"add-product","add-testimonial":"add-testimonial","edit-news":"edit-news","edit-product":"edit-product","edit-testimonial":"edit-testimonial","edit-company":"edit-company","edit-member":"edit-member","edit-editable-content":"edit-editable-content","feedback-reply":"feedback-reply","add-project":"add-project","banners~cms-news~companies~feedbacks~gallery~products~projects~services~subscribers~team~testimonials":"banners~cms-news~companies~feedbacks~gallery~products~projects~services~subscribers~team~testimonials","products":"products","projects":"projects","services":"services","banners":"banners","cms-news":"cms-news","companies":"companies","feedbacks":"feedbacks","gallery":"gallery","subscribers":"subscribers","team":"team","testimonials":"testimonials","change-password":"change-password","company~company-detail":"company~company-detail","company":"company","company-detail":"company-detail","contact-us":"contact-us","edit-project":"edit-project","feedback-detail":"feedback-detail","forgot-password":"forgot-password","login":"login","news":"news","newsDetail":"newsDetail","not-found":"not-found","privacy-policy":"privacy-policy","reset-password":"reset-password","terms-conditions":"terms-conditions"}[chunkId]||chunkId) + "." + {"about~home~products~projects~services":"a7bd0b74","about":"9921fdb6","home":"dde32d2e","add-album~add-banner~add-company~add-member~add-news~add-product~add-testimonial~edit-album~edit-com~bfaa3580":"8435c02d","add-album~edit-album":"934266d9","add-album":"4ae6586f","edit-album":"45ac66b1","add-banner":"bb1d54cc","add-company":"d0cf93c8","add-member":"dc50be46","add-news~add-product~add-testimonial~edit-editable-content~edit-news~edit-product~edit-testimonial~f~2d145b4d":"c83016ca","add-news":"85ad85fb","add-product":"1aaaea2e","add-testimonial":"e0bf8c1e","edit-news":"41b4bb38","edit-product":"151298c3","edit-testimonial":"fdaf36ce","edit-company":"1e9a9744","edit-member":"4dedbe38","edit-editable-content":"24ec1d7b","feedback-reply":"3c7c8e24","add-project":"9020f204","banners~cms-news~companies~feedbacks~gallery~products~projects~services~subscribers~team~testimonials":"c596b299","products":"12f51fa8","projects":"deb8ee00","services":"c2cfe18a","banners":"12f66b10","cms-news":"7919aa1d","companies":"7643eb0d","feedbacks":"1df5aeeb","gallery":"53aa24f2","subscribers":"6a8d9a9c","team":"33b22d60","testimonials":"f02384c2","change-password":"9345bc78","company~company-detail":"6b15a5e3","company":"d0c6efb5","company-detail":"4d4955b3","contact-us":"50130bb0","edit-project":"cd80c149","feedback-detail":"4ccffa80","forgot-password":"be02483f","login":"7637edc8","news":"0bae630c","newsDetail":"6b0891c3","not-found":"992a0727","privacy-policy":"f9502048","reset-password":"30c3190f","terms-conditions":"d914c729"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about~home~products~projects~services":1,"about":1,"home":1,"add-album~add-banner~add-company~add-member~add-news~add-product~add-testimonial~edit-album~edit-com~bfaa3580":1,"add-album~edit-album":1,"add-banner":1,"add-company":1,"add-member":1,"add-news~add-product~add-testimonial~edit-editable-content~edit-news~edit-product~edit-testimonial~f~2d145b4d":1,"add-news":1,"add-product":1,"add-testimonial":1,"edit-news":1,"edit-product":1,"edit-testimonial":1,"edit-company":1,"edit-member":1,"edit-editable-content":1,"feedback-reply":1,"add-project":1,"banners~cms-news~companies~feedbacks~gallery~products~projects~services~subscribers~team~testimonials":1,"products":1,"projects":1,"services":1,"feedbacks":1,"gallery":1,"change-password":1,"company~company-detail":1,"contact-us":1,"edit-project":1,"feedback-detail":1,"forgot-password":1,"login":1,"news":1,"newsDetail":1,"not-found":1,"privacy-policy":1,"reset-password":1,"terms-conditions":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about~home~products~projects~services":"about~home~products~projects~services","about":"about","home":"home","add-album~add-banner~add-company~add-member~add-news~add-product~add-testimonial~edit-album~edit-com~bfaa3580":"add-album~add-banner~add-company~add-member~add-news~add-product~add-testimonial~edit-album~edit-com~bfaa3580","add-album~edit-album":"add-album~edit-album","add-album":"add-album","edit-album":"edit-album","add-banner":"add-banner","add-company":"add-company","add-member":"add-member","add-news~add-product~add-testimonial~edit-editable-content~edit-news~edit-product~edit-testimonial~f~2d145b4d":"add-news~add-product~add-testimonial~edit-editable-content~edit-news~edit-product~edit-testimonial~f~2d145b4d","add-news":"add-news","add-product":"add-product","add-testimonial":"add-testimonial","edit-news":"edit-news","edit-product":"edit-product","edit-testimonial":"edit-testimonial","edit-company":"edit-company","edit-member":"edit-member","edit-editable-content":"edit-editable-content","feedback-reply":"feedback-reply","add-project":"add-project","banners~cms-news~companies~feedbacks~gallery~products~projects~services~subscribers~team~testimonials":"banners~cms-news~companies~feedbacks~gallery~products~projects~services~subscribers~team~testimonials","products":"products","projects":"projects","services":"services","banners":"banners","cms-news":"cms-news","companies":"companies","feedbacks":"feedbacks","gallery":"gallery","subscribers":"subscribers","team":"team","testimonials":"testimonials","change-password":"change-password","company~company-detail":"company~company-detail","company":"company","company-detail":"company-detail","contact-us":"contact-us","edit-project":"edit-project","feedback-detail":"feedback-detail","forgot-password":"forgot-password","login":"login","news":"news","newsDetail":"newsDetail","not-found":"not-found","privacy-policy":"privacy-policy","reset-password":"reset-password","terms-conditions":"terms-conditions"}[chunkId]||chunkId) + "." + {"about~home~products~projects~services":"54a34b2e","about":"f8da2812","home":"46b83e73","add-album~add-banner~add-company~add-member~add-news~add-product~add-testimonial~edit-album~edit-com~bfaa3580":"9c79cd0c","add-album~edit-album":"d030e4cf","add-album":"31d6cfe0","edit-album":"31d6cfe0","add-banner":"132a9307","add-company":"132a9307","add-member":"132a9307","add-news~add-product~add-testimonial~edit-editable-content~edit-news~edit-product~edit-testimonial~f~2d145b4d":"8900952c","add-news":"651fde66","add-product":"132a9307","add-testimonial":"132a9307","edit-news":"8c65c44d","edit-product":"132a9307","edit-testimonial":"132a9307","edit-company":"132a9307","edit-member":"132a9307","edit-editable-content":"9c79cd0c","feedback-reply":"9c79cd0c","add-project":"9c79cd0c","banners~cms-news~companies~feedbacks~gallery~products~projects~services~subscribers~team~testimonials":"9c79cd0c","products":"0f821c09","projects":"766dbf63","services":"c56ed3ec","banners":"31d6cfe0","cms-news":"31d6cfe0","companies":"31d6cfe0","feedbacks":"76e26cdd","gallery":"1f5501f4","subscribers":"31d6cfe0","team":"31d6cfe0","testimonials":"31d6cfe0","change-password":"9c79cd0c","company~company-detail":"38f3debd","company":"31d6cfe0","company-detail":"31d6cfe0","contact-us":"244d5c43","edit-project":"9c79cd0c","feedback-detail":"9c79cd0c","forgot-password":"dcc08d8f","login":"dcc08d8f","news":"f599a5a3","newsDetail":"46ad9bea","not-found":"f417bd86","privacy-policy":"77c1bdf9","reset-password":"dcc08d8f","terms-conditions":"77c1bdf9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
